export default __webpack_public_path__ + "static/media/mobile-bottom-curve.0473e943.svg";